import axios from '../../../boot/axios';
import { buildFetchUrl } from "../../../helpers/url";

export default {
    
    createMoneyManagement(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/createMoneyManagement', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    getMoneyManagement(_) {
        return new Promise((resolve, reject) => {
            axios.get('api/v1/getMoneyManagement')
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    
    deleteMoneyManagement(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/deleteMoneyManagement', payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    getMoneyDetails(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getMoneyDetails', payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    saveMoneyDetails(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/saveMoneyDetails', payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
}